/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_Helpful_Ox_HushInputs */

const fr_fit_helpful_ox_hush = /** @type {(inputs: Fit_Helpful_Ox_HushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, ICO, SVG — recommandé 32×32px`)
};

/**

* @param {Fit_Helpful_Ox_HushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fit_helpful_ox_hush = /** @type {((inputs?: Fit_Helpful_Ox_HushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_Helpful_Ox_HushInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fit_helpful_ox_hush(inputs)
});